import React from "react";

export interface ITenant {
  Id: string,
  Name: string,
  Roles: string[],
  IsInRole: (role: string) => boolean;
}

interface ITenantContext {
  currentTenant: ITenant;
  setCurrentTenantById: (tenantId: string) => void;
  tenants: ITenant[];
  //setTenants: (value: ITenant[]) => void;  
}

const TenantContext = React.createContext<ITenantContext>({
  currentTenant: { Id:"", Name:"", Roles: [], IsInRole: (role: string) => false },
  setCurrentTenantById: () => { },
  tenants: [],
  //setTenants: () => { }
});

export default TenantContext;
